<script>
  import { createEventDispatcher, onMount } from 'svelte'
  import Fa from 'svelte-fa'
  import {
    faArrowDown,
    faArrowLeft,
    faArrowRight,
    faArrowUp,
    faMusic,
    faCalendar,
    faCheck,
    faClipboard,
    faClock,
    faComment,
    faMicrochip,
    faAsterisk,
    faTimes,
    faCut,
    faTrashAlt,
    faTimesCircle,
    faEdit,
    faEllipsisH,
    faEllipsisV,
    faEnvelope,
    faServer,
    faEyeSlash,
    faFile,
    faFolder,
    faFolderOpen,
    faGlobe,
    faBars,
    faHome,
    faImage,
    faKey,
    faThumbsUp,
    faList,
    faLock,
    faLockOpen,
    faSlidersV,
    faBell,
    faBellSlash,
    faSync,
    faSearch,
    faCog,
    faShare,
    faMinusCircle,
    faPlusCircle,
    faLayerGroup,
    faStar,
    faTag,
    faTv,
    faUser,
    faVideo,
    faCameraMovie,
    faFilmAlt,
    faPlay,
    faFilm,
    faExclamationTriangle,
    faWifi
  } from '@fortawesome/pro-regular-svg-icons'

  import { updateClasses, cssPrefix } from '../helper-classes.js'

  export let name = null
  export let status = null
  export let iconClass = null
  export let icon = null
  export let dimension = null
  export let tooltip = ''
  export let style = null

  const dispatch = createEventDispatcher()

  let classes = [`${cssPrefix}icon`]

  if (![null, 'primary', 'success', 'info', 'warning', 'error'].includes(status)) {
    console.debug(`[DS:Icon] invalid status ${status}`)
  }

  $: classes = updateClasses(classes, status, 'is-status-' + status, /^is-status/)

  if (iconClass) {
    classes.push(iconClass)
  }

  if (dimension) {
    classes.push('is-dimension-' + dimension)
  }

  // Backwards compatibility for <Icon name="xxx" />
  const names = {
    ArrowDown: faArrowDown,
    ArrowLeft: faArrowLeft,
    ArrowRight: faArrowRight,
    ArrowUp: faArrowUp,
    Audio: faMusic,
    Calendar: faCalendar,
    Check: faCheck,
    Clipboard: faClipboard,
    Clock: faClock,
    Comment: faComment,
    CPU: faMicrochip,
    Created: faAsterisk,
    Cross: faTimes,
    Cut: faCut,
    Delete: faTrashAlt,
    DeleteCircle: faTimesCircle,
    Edit: faEdit,
    EllipsisHorizontal: faEllipsisH,
    EllipsisVertical: faEllipsisV,
    Email: faEnvelope,
    Encoder: faServer,
    EyeOff: faEyeSlash,
    File: faFile,
    Folder: faFolder,
    FolderOpen: faFolderOpen,
    Globe: faGlobe,
    Hamburger: faBars,
    Home: faHome,
    Image: faImage,
    Key: faKey,
    Like: faThumbsUp,
    List: faList,
    Lock: faLock,
    LockOpen: faLockOpen,
    Mixer: faSlidersV,
    Notification: faBell,
    NotificationOff: faBellSlash,
    Progress: faSync,
    Search: faSearch,
    Setting: faCog,
    Share: faShare,
    SignMinus: faMinusCircle,
    SignPlus: faPlusCircle,
    Stack: faLayerGroup,
    Star: faStar,
    Tag: faTag,
    Television: faTv,
    User: faUser,
    Video: faVideo,
    VideoCamera: faCameraMovie,
    VideoClap: faFilmAlt,
    VideoPlay: faPlay,
    VideoReel: faFilm,
    Warning: faExclamationTriangle,
    Wifi: faWifi
  }

  const nameExists = name && Object.prototype.hasOwnProperty.call(names, name)

  if (!nameExists && !icon) classes.push('is-missing')

  // tooltip
  let tooltipVisible

  function handleMouseEnter() {
    tooltipVisible = true
  }

  function handleMouseLeave() {
    tooltipVisible = false
  }

  onMount(() => {})

  function onClick(event) {
    dispatch('click', event)
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-no-noninteractive-tabindex -->
<div
  class={classes.join(' ')}
  {style}
  on:mouseenter={() => tooltip && handleMouseEnter()}
  on:mouseleave={() => tooltip && handleMouseLeave()}
  on:click={onClick}
  role={tooltip && 'button'}
>
  {#if nameExists}
    <Fa {...$$restProps} icon={names[name]} />
  {:else if icon}
    <Fa {...$$restProps} {icon} />
  {:else}
    <span class={`${cssPrefix}plus`} />
  {/if}
  {#if tooltip}
    <div class={`${cssPrefix}icon-tooltip`} {style} class:hidden={!tooltipVisible}>
      {tooltip}
    </div>
  {/if}
</div>

<style>
  .hidden {
    visibility: hidden;
  }
</style>
